<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <MensagemAlerta class="row-space" v-if="msg" :mensagem="msg" />

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ formatInteger(objEdicao.cdtpproducao) }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption" for="nmtpproducao">Nome/Descrição</label>
                <input type="text" v-model="objEdicao.nmtpproducao" id="nmtpproducao" maxlength="100" v-uppercase />
            </div>
            
            <div class="form-item-char20">
                <TpProdutoMapaSelect class="form-item" v-model:opcaoSelecionada="objEdicao.tpproduto_mapa" />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="detalhamento">Detalhamento</label>
                <textarea v-model="objEdicao.detalhamento" id="detalhamento" maxlength="1000" rows="5" style="resize: none;"/>
            </div>
        </div>


        <div class="row-end">
            <label for="ckAtivo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
        </div>


        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { criarTpProducao } from '@/models/tpproducao';
import { onMounted, ref } from 'vue';
import { formatInteger } from '@/funcoes/utils';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import TpProdutoMapaSelect from '@/selects/estaticos/TpProdutoMapaSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo = ref(false);
const isLoading = ref(false);
const msg = ref(null);
const objEdicao = ref(criarTpProducao());

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value = true;
        msg.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('tpproducao', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msg.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
        }
        objEdicao.value.idlogin         = globalStore.idlogin;
        ckAtivo.value                   = objEdicao.value.ativo === 'S';        
    } catch (error) {msg.value = error;
    }finally{isLoading.value=false;}
};

const salvarDados = async() => {
    try {
        if (!objEdicao.value.nmtpproducao) throw new Error('Informe o nome do tipo de producao');
        if (!objEdicao.value.tpproduto_mapa) throw new Error('Informe o tipo de produto');
        isLoading.value                 = true;
        msg.value                       = null;
        objEdicao.value.ativo           = ckAtivo.value ? 'S' : 'N';
        const response                  = await genericPut('/cad/tpproducao', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msg.value = response.erro;
        }
    } catch (error){msg.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>